import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/dnDesignSystem/components/ui/accordion';
import { PopularTreatmentCategoryModel, TreatmentCategoryModel } from '@/models/diagnosis/category';
import { ECategoryType } from '@/services/doctor/DiagnosisCategoryService';
import { ROUTES } from '@/types/common';
import { addQueryString } from '@/utils/url';
import Link from 'next/link';

interface Props {
  popularTreatmentCategories: PopularTreatmentCategoryModel[];
  treatmentCategories: TreatmentCategoryModel[];
}

const TreatmentCategoriesInfo = (props: Props) => {
  return (
    <div className={'flex flex-col'}>
      <section className={'border-gray-50 border-t-0 border-r-0 border-b border-solid px-[24px] pt-[40px] pb-[20px]'}>
        <h2 className={'typography-ui-17sb text-gray-600'}>많이 찾는 증상</h2>
        <ul className={'mt-[20px] flex flex-wrap items-center gap-[8px]'}>
          {props.popularTreatmentCategories.map((category) => {
            return (
              <li key={`popular-treatment-category-${category.id}`}>
                <Link
                  href={
                    ROUTES.TELEMEDICINE.DOCTORS.path +
                    addQueryString({
                      type: ECategoryType.Treatment,
                      id: category.id,
                    })
                  }
                >
                  <a className={'flex h-[36px] items-center rounded-[40px] bg-gray-30 px-[16px]'}>
                    <h3 className={'typography-ui-15m text-gray-700'}>{category.name}</h3>
                  </a>
                </Link>
              </li>
            );
          })}
        </ul>
      </section>
      <section>
        <Accordion type={'multiple'}>
          {props.treatmentCategories.map((treatmentCategory) => {
            return (
              <AccordionItem key={`treatment-category-${treatmentCategory.id}`} value={treatmentCategory.id}>
                <AccordionTrigger variant={'lg'}>
                  <div className={'flex items-center gap-[12px]'}>
                    <img
                      src={treatmentCategory.icon}
                      alt={treatmentCategory.name}
                      className={'aspect-square h-[32px]'}
                    />
                    <h2 className={'typography-ui-17sb text-gray-600'}>{treatmentCategory.name}</h2>
                  </div>
                </AccordionTrigger>
                <AccordionContent>
                  {treatmentCategory.treatments.length > 0 && (
                    <ul className={'flex flex-wrap items-center gap-[8px] px-[24px] py-[20px]'}>
                      {treatmentCategory.treatments.map((treatment) => {
                        return (
                          <li key={`popular-treatment-category-${treatment.id}`}>
                            <Link
                              href={
                                ROUTES.TELEMEDICINE.DOCTORS.path +
                                addQueryString({
                                  type: ECategoryType.Treatment,
                                  id: treatment.id,
                                })
                              }
                            >
                              <a className={'flex h-[36px] items-center rounded-[40px] bg-gray-30 px-[16px]'}>
                                <h3 className={'typography-ui-15m text-gray-700'}>{treatment.name}</h3>
                              </a>
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>
      </section>
    </div>
  );
};

export default TreatmentCategoriesInfo;
